import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=1836411a&"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js&"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports